
import React from 'react'
interface Props {
  rotation: number
}
export const ArrowIcon: React.FC<Props> = ({ rotation }) => {
  const style = {
    stroke: 'currentcolor',
    fill: 'none',
    strokeLinejoin: 'round' as "round",
    strokeLinecap: 'round' as "round",
    strokeWidth: '2',
    vectorEffect: 'non-scaling-stroke' as 'non-scaling-stroke',
  }
  return (
    <svg
      viewBox='0 0 20 20'
      className='arrow-icon'
      style={{ transform: 'rotateZ(' + rotation + 'deg)' }}
    >
      <line x1='2' x2='18' y1='10' y2='10' style={style} />
      <path d='M 10.5 2.5 L 18 10 L 10.5 17.5' style={style} />
    </svg>
  )
}
